import React, { Fragment } from 'react';
import { useProtocolList } from './useProtocolList';
import { ProtocolListSkeleton } from './ProtocolListSkeleton';
import { ProtocolFilter } from './ProtocolFilter';
import { ContextMenu } from '../../common/components';
import { Pagination } from '../../common/components/Pagination';
import { PopUp } from '../../common/components/PopUp';
import {
  ProtocolListContainer,
  StyledPageTitle,
  TableCard,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledProtocolNumberCell,
  StyledLockIcon,
  StyledWarningIcon,
  PaginationWrapper
} from './styles';
import { dateHelper } from '../../helpers';

export const ProtocolList: React.FC = (): JSX.Element => {
  const {
    columns,
    loading,
    message,
    count,
    data,
    options,
    contextMenu,
    contextMenuItems,
    limit,
    offset,
    page,
    navigate,
    togglePopup,
    handleFilterSubmit,
    handlePagination,
    handleLimitChange,
    handleContextMenu,
    handleCloseContextMenu,
  } = useProtocolList();

  return (
    <ProtocolListContainer>
      {message && <PopUp type={message.type} message={message.message} toggle={togglePopup} />}

      <StyledPageTitle>
        <h1>Přehled protokolů</h1>
      </StyledPageTitle>

      <ProtocolFilter onSubmit={handleFilterSubmit} options={options} />

      <TableCard>
        <StyledTable>
          <StyledTableHead>
            <tr>
              {columns.map((column, key) => (
                <th key={key}>
                  <div>
                    {column.label} {column.order}
                  </div>
                </th>
              ))}
            </tr>
          </StyledTableHead>
          <StyledTableBody>
            {loading && !data ? (
              <ProtocolListSkeleton />
            ) : (
              data?.map((item, key) => (
                <Fragment key={key}>
                  <tr onContextMenu={(e) => handleContextMenu(e, item.id, item.is_locked, item.is_deactivated)} className={item.is_locked ? 'locked' : ''}>
                    <td
                      className="clickable"
                      onClick={() => navigate(`/protocol/${item.id}/patient`)}>
                      {item.full_name ? item.full_name : <i>nezjištěno</i>}
                    </td>
                    <td
                      className="clickable"
                      onClick={() => navigate(`/protocol/${item.id}/protocol`)}>
                      <StyledProtocolNumberCell>
                        {item.protocol_display}
                        {item.is_locked && <StyledLockIcon>🔒</StyledLockIcon>}
                        {item.is_deactivated && <StyledWarningIcon>⚠️</StyledWarningIcon>}
                      </StyledProtocolNumberCell>
                    </td>
                    <td>{item.pathologist1_name}</td>
                    <td>{item.pathologist2_name}</td>
                    <td>{item.has_k_davka ? '✓' : '-'}</td>
                    <td>{item.sent_to_uzis_at ? dateHelper.formatDateCZ(item.sent_to_uzis_at) : '-'}</td>
                    <td>{item.has_active_request ? '✓' : '-'}</td>
                    <td>
                      {item.title_before} {item.title_after}
                    </td>
                    <td>{item.birth_id}</td>
                    <td><span className="line-clamp-2" title={item.insurance_company_name}>{item.insurance_company_name}</span></td>
                    <td>{item.date_of_birth ? dateHelper.formatDate(item.date_of_birth) : <i>neznámé</i>}</td>
                    <td>{item.date_of_death ? dateHelper.formatDate(item.date_of_death) : <i>neznámé</i>}</td>
                    <td>{item.age_years}</td>
                    <td><span className="line-clamp-2" title={item.residence_address}>{item.residence_address}</span></td>
                    <td>{item.contact}</td>
                    <td><span className="line-clamp-2" title={item.note}>{item.note}</span></td>
                  </tr>
                </Fragment>
              ))
            )}
          </StyledTableBody>
        </StyledTable>
      </TableCard>

      {data && (
        <>
          <ContextMenu
            isOpen={contextMenu.isOpen}
            x={contextMenu.x}
            y={contextMenu.y}
            items={contextMenuItems}
            onClose={handleCloseContextMenu}
          />

          <PaginationWrapper>
            <Pagination
              count={count}
              offset={offset}
              page={page}
              limit={limit}
              onSubmit={handlePagination}
              onLimitChange={handleLimitChange}
            />
          </PaginationWrapper>
        </>
      )}
    </ProtocolListContainer>
  );
};
